import { checkAuthentication } from '../../api/api';

class AiRequestError extends Error {
  constructor(httpStatus, body) {
    super(body?.message || '');
    this.httpStatus = httpStatus;
    this.data = body?.data;
  }
}

// Plain fetch instead of DBRequest: DBRequest never settles on network errors
// or non-JSON bodies, which would hang the composer and stack up polls offline.
export async function request(config, path, method) {
  let res;
  try {
    res = await fetch(config.API_URL + path, method);
  } catch {
    throw new AiRequestError(0, null);
  }
  const body = res.status === 204 ? null : await res.json().catch(() => null);
  if (!res.ok) {
    checkAuthentication(res.status);
    throw new AiRequestError(res.status, body);
  }
  return body || {};
}
